var alert = {
  "alert": {
    "backgroundColor": "#fff",
    "borderRadius": "0",
    "display": "flex",
    "minWidth": "120px",
    "position": "relative",
    "&:not(.alertDialog) a": {
      "textDecoration": "underline"
    }
  },
  "alertNeutral": {
    "color": "#53565a",
    "border": "0.0625rem solid #97999b",
    "&:not(.alertDialog) a": {
      "color": "#53565a"
    },
    "&:not(.alertDialog) a:hover": {
      "color": "#53565a"
    }
  },
  "alertNeutral__icon": {
    "color": "#97999b"
  },
  "alertPositive": {
    "color": "#008767",
    "border": "0.0625rem solid #008767",
    "&:not(.alertDialog) a": {
      "color": "#008767"
    },
    "&:not(.alertDialog) a:hover": {
      "color": "#008767"
    }
  },
  "alertPositive__icon": {
    "color": "#008767"
  },
  "alertWarn": {
    "color": "#b42c01",
    "border": "0.0625rem solid #b42c01",
    "&:not(.alertDialog) a": {
      "color": "#b42c01"
    },
    "&:not(.alertDialog) a:hover": {
      "color": "#b42c01"
    }
  },
  "alertWarn__icon": {
    "color": "#b42c01"
  },
  "alertDismissible": {
    "alignItems": "center",
    "marginBottom": "1.25rem",
    "paddingLeft": "1.25rem",
    "paddingRight": "1.25rem"
  },
  "alertDismissible___all_children": {
    "&:not(.icon):not(.glyph)": {
      "paddingRight": "0.625rem",
      "paddingLeft": "0.625rem",
      "margin": "1.25rem auto",
      "flex": "1"
    }
  },
  "alertDialog": {
    "borderColor": "#ecedee",
    "color": "#000",
    "display": "block",
    "fontSize": "0.9375rem",
    "padding": "1.5625rem",
    "textAlign": "center"
  },
  "alertDialog__icon": {
    "paddingBottom": "0.78125rem"
  },
  "alertDialog__alertSeparator": {
    "margin": "1.25rem -1.25rem 0",
    "paddingBottom": "1.25rem"
  }
};

export default alert;
